import axios from "axios";

export const state = () => ({
  list: {},
});

export const getters = {};

export const mutations = {
  SET_LIST(state, {entity_id, favorite}) {
    state.list = {
      ...state.list,
      [entity_id]: favorite,
    };
  },
};

export const actions = {
  check({dispatch, commit, state, rootGetters}, {entity_id}) {
    return axios
      .get(`/trailer/api/v1/settings`, {
        cache: true,
        params: {
          page: 1, page_size: 1,
          entity_id,
          key: `favorite.${rootGetters['auth/user'].id}`
        },
      })
      .then(({data: {Body = []} = {}}) => {
        console.info('state/favorite/check | result = ', Body);

        const favorite = (Body || [])[0] || {};
        commit('SET_LIST', {entity_id, favorite});
        return favorite;
      });
  },
  set({dispatch, commit, state, rootGetters}, {entity_id, entity_type, is}) {
    const userId = rootGetters['auth/user'].id;
    const key = `favorite.${userId}`;
    const url = `/trailer/api/v1/settings/slim/entity-id:${entity_id}/key:${key}`

    let apiCall;
    if (is) {
      apiCall = axios.post(url, {entity_type, value: 'true'});
    } else {
      apiCall = axios.delete(url);
    }

    return apiCall.then(({data}) => {
      console.info('state/favorite/set | is = ', String(is), ' | data = ', data);

      const favorite = is ? data : {};
      commit('SET_LIST', {entity_id, favorite});
      return favorite;
    });
  },
};
